import { canonicalizeSpeakerDisplayName } from '../../../utils/speaker-display-names';

export const LANG_LABELS: Record<string, string> = {
  ru: 'RU',
  kz: 'KZ',
  en: 'EN',
  mixed: 'RU+KZ',
  unknown: '?',
};

export function langLabel(code?: string | null): string {
  if (!code) return '—';
  return LANG_LABELS[code] || code.toUpperCase();
}

export function resolveSpeakerLang(
  speakerLabel: string | undefined,
  displayName: string,
  langs: Record<string, string>,
): string | undefined {
  if (speakerLabel && langs[speakerLabel]) return langs[speakerLabel];
  if (langs[displayName]) return langs[displayName];

  const m = speakerLabel?.match(/SPEAKER_(\d+)/i);
  if (m) {
    const padded = `SPEAKER_${parseInt(m[1], 10).toString().padStart(2, '0')}`;
    if (langs[padded]) return langs[padded];
    const plain = `SPEAKER_${parseInt(m[1], 10)}`;
    if (langs[plain]) return langs[plain];
  }
  return undefined;
}

export function formatSpeakerWithLang(name: string, lang?: string | null): string {
  const display = canonicalizeSpeakerDisplayName(name);
  if (lang && ['ru', 'kz', 'en', 'mixed'].includes(lang)) {
    return `${display} (${langLabel(lang)})`;
  }
  return display;
}
